import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const Scroll = ({ className }) => {
  return (
    <svg
      width='22'
      height='22'
      viewBox='0 0 22 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={classnames('icon', 'icon-scroll', { [className]: className })}
    >
      <path d='M22 0L17.1813 22H11L15.8187 0H22Z' fill='currentColor' />
      <path d='M0 0L4.81872 22H11L6.18128 0H0Z' fill='currentColor' />
    </svg>
  );
};

Scroll.propTypes = {
  className: PropTypes.string,
};

export default Scroll;
